{
  "el": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Αλλαγή φάσης",
        "reset_columns": "Επαναφορά στηλών"
      },
      "labels": {
        "columns": "Στήλες",
        "milestone": "Επίλεξε μια νέα φάση",
        "no_results": "Δεν βρέθηκαν ακίνητα"
      }
    }
  }
}
